import { reportUiFailure } from "../report-failure.js";

// CYBORG-1561: a status frame for a session the roster does not hold yet, or holds as a cybo DM
// session not yet promoted to the pair's default (its first frame lands before the promotion),
// re-reads the roster, so the open DM switches to that session live and shows its turn — the
// failure card included — exactly as a reload would.
// ponytail: capped per agent, one read in flight; a session that never settles stops after `cap`.
export function rosterSettled(
  row: { cyboId?: string | null; channelId?: string | null; isDefault?: boolean } | undefined,
): boolean {
  return !!row && (row.isDefault === true || !row.cyboId || !!row.channelId);
}

export class UnknownAgentRelist {
  private readonly tries = new Map<string, number>();
  private inFlight = false;

  constructor(private readonly cap = 3) {}

  note(agentId: string, known: boolean, relist: () => Promise<unknown>): void {
    if (known || this.inFlight) return;
    const n = this.tries.get(agentId) ?? 0;
    if (n >= this.cap) return;
    this.tries.set(agentId, n + 1);
    this.inFlight = true;
    void this.run(agentId, relist); // never rejects: run() reports
  }

  private async run(agentId: string, relist: () => Promise<unknown>): Promise<void> {
    try {
      await relist();
    } catch (err) {
      reportUiFailure("agents.relist_unknown_agent", err, { agentId });
    } finally {
      this.inFlight = false;
    }
  }

  reset(): void {
    this.tries.clear();
    this.inFlight = false;
  }

  size(): number {
    return this.tries.size;
  }
}
